import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Camera = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="camera icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 8C0 5.79086 1.79086 4 4 4H4.92963C5.59834 4 6.2228 3.6658 6.59373 3.1094L7.40627 1.8906C7.7772 1.3342 8.40166 1 9.07037 1H14.9296C15.5983 1 16.2228 1.3342 16.5937 1.8906L17.4063 3.1094C17.7772 3.6658 18.4017 4 19.0704 4H20C22.2091 4 24 5.79086 24 8V19C24 21.2091 22.2091 23 20 23H4C1.79086 23 0 21.2091 0 19L0 8ZM12 19C8.69565 19 6 16.2945 6 12.9782C6 9.66181 8.69565 6.99999 12 6.99999C15.3043 6.99999 18 9.70545 18 13.0218C18 16.3382 15.3043 19 12 19ZM15.75 13C15.75 10.929 14.071 9.25 12 9.25C9.92898 9.25 8.25 10.929 8.25 13C8.25 15.071 9.92898 16.75 12 16.75C14.071 16.75 15.75 15.071 15.75 13Z"
    />
  </svg>
)
